<!--
 * @Author: your name
 * @Date: 2022-01-11 11:09:19
 * @LastEditTime: 2022-01-25 00:52:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \longzhu-PC\src\pages\roomLive.vue
-->
<template>
  <div  :class="showminSlide?'showminSlide':''">
    <Nav ref="navRef" @changeLogin='changeLogin' :rType="6" @routerType="changePage"></Nav>
    <div style="height: 80px"></div>
    <div class="homeLive_content">
      <div class="home-left">
        <Aside ref="MyAside" @changeAside='changeAside' @changeChildAside='changeChildAside'  :pageType='1' @Changeslide = 'Changeslide'  @login='login'></Aside>
      </div>
      <div class="home-right">
            <BroadcastComponent
              :key="domkey"
              class="mylists"
              @save="save"
              ref="roominfo"
              @emitLongin="emitLongin"
            ></BroadcastComponent>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "../component/Nav.vue";
import BroadcastComponent from "../component/BroadcastComponent.vue";
import merge from "webpack-merge";
import axios from "axios";
import qs from "qs";
import Aside from "@/components/lz_leftAside.vue";
import GlobalInfo from "@/lib/scoreSocket.js";
import Bus from '@/lib/bus.js';
export default {
  components: {
    Nav,
    BroadcastComponent,Aside
  },
  data() {
    return {
      showminSlide:true,
      domkey:1,
      matchId: "",
      careList: [],
      pcatId: "",
      first_soft: 1000,
      childIndex: 1000,
      routerIndex: 1,
      shouyeData: [],
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    },
    nameFilters(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    },
  },
  created() {
    this.initData();
    this.initGlobal();
    let that = this;
  },
  methods: {
    Changeslide(v){
        console.log('打开关闭',v);
        this.showminSlide = v;
    },
    login(){
      this.$refs.navRef.Longin();
    },
    changeChildAside(obj){
      console.log('子分类',obj);
      this.$NewRouter(`/v2/lives/${obj.infoId}?c1=${obj.infoId}&c2=${obj.valId}`);
      // this.$router.push({
      //   path:'pageLive',
      //   query:{
      //     rid: 1,
      //     infoId:obj.infoId,
      //     valId:obj.valId
      //   },
      // });
    },
    changeAside(e) {
      switch (e) {
        case 5:
          console.log('获取子分类内容',e);
          this.$NewRouter(`/v2/lives/all`);
          // this.$router.push({
          //   path:'pageLive',
          //   query:{
          //     rid: 1,
          //     infoId: 1,
          //     valId: ''
          //   },
          // });
          break;
        case 6:
          if(!localStorage.getItem('token')){
            this.login()
            return
          }
          console.log('我的关注内容');
          let newurl = `/v2/lives/follow`
          this.$NewRouter(newurl);
          // this.$router.push({
          //   path:'pageLive',
          //   query:{
          //     rid: 1,
          //     infoId: 999,
          //     valId: ""
          //   },
          // });
          break;
        case 7:
        if(!localStorage.getItem('token')){
          this.login()
          return
        }
          console.log('浏览记录内容');
          this.$NewRouter( `/v2/lives/history`);
          // this.$router.push({
          //   path:'pageLive',
          //   query:{
          //     rid: 1,
          //     infoId: 1000,
          //     valId:1
          //   },
          // });
          break;
        default:
          break;
      }
      console.log('');
    },
    // 获取主播关联的比赛信息
    changeLogin(){
      this.$nextTick(()=>{
        if(this.$refs.roominfo){
          console.log('重新登录--刷新组件');
          this.$refs.roominfo.initRoomInfo()
        }else{
          console.log('需要重新获取组件');
          this.domkey ++
        }
      })
    },
    async initGlobal() {
      GlobalInfo.sucess = (e) => {
        let Info = JSON.parse(e.data);
        console.log("直播间比分socket", Info.messageType,Info.message);
        this.$nextTick(()=>{
          if(this.$refs.roominfo){
            this.$refs.roominfo.changeChild(Info)
          }else{
            console.log('需要重新获取组件');
            this.domkey ++
          }
        })
      };
    },
    save() {
      console.log(123);
      this.$refs.navRef.Pay();
    },
    emitLongin() {
      console.log(123);
      this.$refs.navRef.Longin();
    },
    // 分类列表
    initData() {
      this.imageTime = Date.parse(new Date()) / 1000;
    },
    getcare() {
      if(localStorage.getItem('token')){
        // this.$router.replace('/pageLive?rid=1&infoId=999&valId= 2');
        this.$NewRouter( `/v2/lives/follow`);
      }
    },
    // 切换路径
    changePage(e) {
      this.routerIndex = e;
      console.log("页面路径 :>> ", e);
    },
  },
};
</script>
<style lang="scss" scope >
@import "../assets/style/index.scss"; //引入全局scss
  @import '../assets/style/flex.scss';
.homeLive_content {
  display: flex;
  height: calc(100vh - 90px);
  overflow: hidden;
  // overflow: hidden;
  // min-width: 1300px;
}
// div {
//   user-select: none;
// }
.showminSlide{
    .bg-purple1{
      width: 64px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all .6s;
    }
    .biglogo{
      display: none !important;
    }
    .minlogo{
      display: block !important;
    }
    .broadcast{
      .setiframe{
        height: calc((100vw - 426px) / 1.77 )!important;
      }
      .details-top-right-center2{
        transition: all .6s;
          height: calc((100vw - 426px) / 1.77 )!important;
      }
      .content_box{
        transition: all .6s;
        width: calc(100vw - 426px) !important;
      }
    }
}
.mylists {
  .home-right-div {
    display: flex;
    height: 76px;
    flex-flow: column wrap;
    box-sizing: border-box;
    padding: 8px;
    .hotValue {
      display: flex;
      margin-top: 8px;
    }
    .video_list_img {
      width: 22px;
      height: 22px;
      margin-right: 4px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 22px;
        height: 22px;
      }
    }
  }
}
  .home-left {
    // min-width: 160px;
    // width:240px;
    background: #f7f8fa;
    padding-top: 2px;
    box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.1);
    color: #666;

    div {
      user-select: none;
    }

    .soft_line {
      margin: 10px 0;
      height: 1px;
      width: 100%;
      background: rgba(46, 48, 52, 0.1);
    }

    .btnActive {
      color: $colorHover !important;
    }

    .home_left_soft {
      display: flex;
      flex-direction: column;
    }

    .left_item {
      width: 204px;
      display: flex;
      padding: 0 18px;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 48px;
      transition: all 0.7s;

      // border: 1px solid red;
      .active_left {
        color: $colorHover !important;
      }

      cursor: pointer;

      .snmae {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;

        div {
          margin: 0;
          height: 20px;
          line-height: 20px;
          padding: 0;
        }

        img {
          margin-right: 8px;
          width: 20px;
          height: 20px;
          // width: 100%;
        }
      }

      .soft_childre {
        display: flex;
        text-align: center;
        flex-flow: row wrap;
        padding: 2px;
        opacity: 0;
        height: 0;
        overflow: hidden;
        // box-sizing: border-box;
        // padding: 10px 0;
        transition: all 0.5s;
        .soft_childre_item {
          padding: 4px 0;
          margin: 4px 2px;
          border-radius: 4px;
          min-width: 50px;
          background-color: #f7f7f7;
          font-size: 12px;
          color: #333;
        }

        .soft_childre_item:hover {
          color: #fff;
          background-color: $colorHover;
        }
      }
    }

    .left_item:hover {
      .snmae {
        color: $colorHover;
      }
    }
  }

.home-right {
  background: #f7f8fa;
  flex: 2;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

}
</style>



// WEBPACK FOOTER //
// src/pages/roomLive.vue